import { render, staticRenderFns } from "./DepartmentEmployeeTransfer.vue?vue&type=template&id=7b732422&scoped=true"
import script from "./DepartmentEmployeeTransfer.vue?vue&type=script&lang=js"
export * from "./DepartmentEmployeeTransfer.vue?vue&type=script&lang=js"
import style0 from "./DepartmentEmployeeTransfer.vue?vue&type=style&index=0&id=7b732422&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b732422",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b732422')) {
      api.createRecord('7b732422', component.options)
    } else {
      api.reload('7b732422', component.options)
    }
    module.hot.accept("./DepartmentEmployeeTransfer.vue?vue&type=template&id=7b732422&scoped=true", function () {
      api.rerender('7b732422', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employee/DepartmentEmployeeTransfer.vue"
export default component.exports